import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';
import {getOptionsFromJsonString} from "../../../default/global/js/utilities/options";

export function initEventSlideshow(query = document.querySelectorAll('.eventsList__wrapper.swiper')) {
    for (let slideshow of query) {
        let options = getOptionsFromJsonString(slideshow.dataset.options, {
            autoplay_interval: 300,
            eff_interval: 300,
        });

        let centeredSlides = false;
        if(slideshow.closest('.preview')) {
            centeredSlides = true;
        }

        Swiper.use([Navigation]);
        new Swiper(slideshow, {
            speed: 300,
            spaceBetween: 0,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            slidesPerGroup: 1,
            autoHeight: false,
            navigation: {
                nextEl: slideshow.querySelector('.swiper-button-next'),
                prevEl: slideshow.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                },
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                    centeredSlides: centeredSlides,
                },
            }
        });
    }
}

